import { render } from "./ToolbarButton.vue?vue&type=template&id=12b94284&scoped=true"
import script from "./ToolbarButton.vue?vue&type=script&lang=js"
export * from "./ToolbarButton.vue?vue&type=script&lang=js"

import "./ToolbarButton.vue?vue&type=style&index=0&id=12b94284&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b94284"]])

export default __exports__